import {COMPANY_ID} from '@constants/auth.constant'
import {COMPANY_LIST} from '@constants/internal-route.constant'
import {MyContextProvider} from '@context/MyContext'
import {IAppRoutes} from '@interface/common.interface'
import ChooseCompany from '@modules/auth/ChooseCompany'
import {setWindowTitle} from '@services/helper/common.helper'
import {LocalStorageService} from '@services/utils/localStorage.service'
import {TopProgressCom} from '@services/utils/topProgress.service'
import AuthLayout from 'layouts/AuthLayout'
import {MasterLayout} from 'layouts/MasterLayout'
import {Suspense, useEffect} from 'react'
import {Navigate, Outlet, Route, Routes, useLocation, useNavigate} from 'react-router-dom'
import {AppRouteList} from './routes/app.routes'

const PrivateRoutes = () => {
  setWindowTitle()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const cid: string = LocalStorageService.get(COMPANY_ID)
    if (location.pathname !== COMPANY_LIST && !cid) navigate(COMPANY_LIST)
  }, [location, navigate])

  const routeList = (routes) => {
    return routes.map((route: IAppRoutes, index: number) => {
      if (route.childrens && route.childrens.length) {
        return (
          <Route
            path={route.link}
            element={
              route.element ? (
                <Suspense fallback={<TopProgressCom />}>
                  <route.element />
                </Suspense>
              ) : (
                <>
                  <Outlet />
                </>
              )
            }
            key={index}
          >
            {routeList(route.childrens)}
          </Route>
        )
      }

      return (
        <Route
          path={route.link}
          element={
            route.redirect ? (
              <Navigate to={route.redirect} />
            ) : (
              <Suspense fallback={<TopProgressCom />}>
                <route.element />
              </Suspense>
            )
          }
          key={index}
        />
      )
    })
  }

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={COMPANY_LIST} element={<ChooseCompany />} />
      </Route>
      <Route
        element={
          <MyContextProvider>
            <MasterLayout />
          </MyContextProvider>
        }
      >
        {routeList(AppRouteList)}

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
